import { saveAs } from 'file-saver';
import { valueLabels } from './ExportFollowUpPdf';

const CSV_DELIMITER = ";";

const fmt = (value) => {
  if (value === true) return "Oui";
  if (value === false) return "Non";
  if (value === null || value === undefined || value === "") return "";
  return valueLabels[value] || String(value);
};

const levelLabel = (level) => {
  const levels = { 1: "Niveau I", 2: "Niveau II", 3: "Niveau III", 4: "Niveau IV", 5: "Niveau V" };
  return levels[level] || String(level);
};

const normalizeSelectionList = (value) => {
  if (Array.isArray(value)) return value;
  if (value === null || value === undefined || value === "") return [];
  return [value];
};

const escapeCsvCell = (value, delimiter) => {
  if (value === null || value === undefined) return "";

  const text = String(value);
  if (
    text.includes(delimiter) ||
    text.includes('"') ||
    text.includes("\n") ||
    text.includes("\r")
  ) {
    return `"${text.replace(/"/g, '""')}"`;
  }

  return text;
};

class FollowUpCsvBuilder {
    #delimiter;
    constructor(delimiter) {
        this.#delimiter = delimiter;
    }

    #docHeader = ["Date de soumission", "Nom du kinesiologue", "ID du participant", "Type d'evaluation", "Pour quelle période remplissez-vous ce questionnaire?", 
        "Sur une échelle de 1 à 10, combien donneriez-vous à votre état de santé ? (10 = excellent  1 = très mauvais)  On a scale of 0 to 10, how much would you rate your health ? (10 = excellent 0 = very bad)",
        "Niveau de difficulté du programme / Difficulty level of the program", "Combien de fois avez-vous fait en moyenne par semaine votre programme d'exercices prescrit ? / On average, how many times per week have you been doing your prescribed exercise program?", 
        "Comment avez-vous pratiqué votre prescription ?  How did you practice your prescription ?  [Programme][Échelle 1]",
        "Globalement, comment avez-vous trouvé votre programme d'exercices prescrit ?  How have you found your prescribed exercise program?",
        "Quelle difficulté pratiquez-vous pour chacun des exercices ? [Exercice 1]", "Quelle difficulté pratiquez-vous pour chacun des exercices ? [Exercice 2]",
        "Quelle difficulté pratiquez-vous pour chacun des exercices ?  [Exercice 3]", "Quelle difficulté pratiquez-vous pour chacun des exercices ?  [Exercice 4]",
        "Quel niveau de satisfaction aviez vous de vos séances d'AP? / How satisfied were you with your PA sessions?", 
        "Avez-vous ressenti de la douleur lors de la pratique de votre programme ces dernières semaines ? Si oui, à quelle intensité ?  Have you experienced any pain while doing your program and/or walking in recent weeks? If so, how much pain?",
        "A quelle fréquence ces dernières semaines avez vous ressenti cette douleur durant votre pratique ?  How often this past week(s) have you experienced this pain during your practice?",
        "Quelle est l'origine de ces douleurs ?  What is the origin of these pains?",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Aucune]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Pratique seulement les adaptations faciles des exercices (1 ⭐) (Performs only easy adaptations of exercises)]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Diminution du nombre de répétitions (Decrease in the number of repetitions)]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Augmentation du temps de repos entre les séries (Increased rest time between sets)]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Diminution du nombre de séries (Decrease in the number of sets)]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Suppression d'1 exercice du programme (Removing an exercise from the program)]",
        "Quelle(s) modification(s) avez vous apportée(s) à votre programme pour y remédier ?  What changes have you made to your program to address this?  [Suppression de 2 exercices du programme (Removing an exercise from the program)]",
        "Vous etes-vous senti en sécurité lors de séances d'exercices prescrit / Have you felt safe during prescribed exercise sessions?", 
        "Vous etes-vous senti en sécurité lors de séances d'exercices prescrit /  Have you felt safe during prescribed exercise sessions?  Si non pourquoi",
        "Vous etes-vous senti en sécurité lors de séances d'exercices prescrit / Have you felt safe during prescribed exercise sessions?  Si non noter quelle stratégie a été proposée afin d'augmenter son sentiment de sécurité",
        "Avez-vous marché durant les dernières semaines ? / Did you do any walking during last weeks ? ", "A quelle fréquence ?  How often?", "Durant combien de temps à chaque fois? / For how long each time?", "Comment avez-vous pratiqué votre prescription",
        "Avez-vous chuté durant dernière semaine ? / Have you fallen during the last week(s)?", "Avez-vous chuté durant les dernières semaine ? Si oui, combien de fois ?  Have you fallen during the last week(s)? If so, how much ?",
        "Dans quelles circonstances ? / In which circumstances?  [Raison de chute #1]",
        "Vous sentiez vous motivé(e) pour pratiquer votre prescription d'AP ?  Did you feel motivated to practice your PA prescription?", "Vous sentiez vous motivé(e) pour pratiquer votre prescription d'AP ?  Did you feel motivated to practice your PA prescription? Si non pourquoi",
        "Avez-vous intégré de l'activité physique autre que le programme d'exercice prescrit ? Have you incorporated any physical activity other than the prescribed exercise program?", 
        "Quel type d'activités(s) avez vous pratiquée ?  What type of physical activities have you done?  [Activité 1]",
        "Précisez la fréquence par semaine  de chacune de ces activités", "Précisez la durée de chacune de ces activités", "Précisez l'intensité de chacune de ces activités", "Avez-vous intégré de l'activité physique autre que le programme d'exercice prescrit ? Have you incorporated any physical activity other than the prescribed exercise program?",
        "Quel type d'activités(s) avez vous pratiquée ?  What type of physical activities have you done?  [Activité 2]",
        "Précisez la fréquence par semaine  de chacune de ces activités", "Précisez la durée de chacune de ces activités", "Précisez l'intensité de chacune de ces activités", "Avez-vous intégré de l'activité physique autre que le programme d'exercice prescrit ?  Have you incorporated any physical activity other than the prescribed exercise program?",
        "Quel type d'activités(s) avez vous pratiquée ?  What type of physical activities have you done?  [Activité 3]", 
        "Précisez la fréquence par semaine  de chacune de ces activités", "Précisez la durée de chacune de ces activités", "Précisez l'intensité de chacune de ces activités", 
        "Avez-vu un médecin ?  Have you seen a doctor?", "Si oui Combien de fois ?  How many times ?", "Si oui Raison (s) / Reason (s)",
        "Êtes-vous allé à l'hôpital/chirurgie d'un jour? Have you been to the hospital/day surgery?", "Si oui Combien de fois ? / How many times ?", "Si oui Raison (s) / Reason (s)", 
        "Êtes-vous allé voir un autre professionnel de la santé (physio/ergo/kin )?  Have you seen an other health care professional (physiotherapist/occupational therapist/kinesiologist )?", "Si oui Combien de fois ?  How many times ?", "Si oui Raison (s) / Reason (s)"];
    #docFormat = [this.#docHeader];
    
    addRow(row) {
        this.#docFormat.push(row);
    }

    hasRows() {
        return this.#docFormat.length > 1;
    }

    #convertToText() {
        const maxLen = this.#docFormat.reduce((max, row) => Math.max(max, row.length), 0);

        return this.#docFormat
          .map((row) => {
            const padded = row.concat(Array(Math.max(0, maxLen - row.length)).fill(""));
            return padded
              .map((cell) => escapeCsvCell(cell, this.#delimiter))
              .join(this.#delimiter);
          })
          .join("\r\n");
    }

    saveToFile(patientId, followUpDate, followUpType) {
        if (!this.hasRows()) {
            return false;
        }
        const evalType = (followUpType || "suivi").toUpperCase();
        let fileName = `${followUpDate || "suivi"}_${patientId}_FollowUp_${evalType}.csv`;
        const csvText = `\ufeff${this.#convertToText()}`;
        saveAs(new Blob([csvText],  { type: "text/csv;charset=utf-8;" }), fileName);
        return true;
    }
}

const makeFollowUpPaceRow = (followUp, patientId) => {
     let newRow = [];

    // Informations du patient
    newRow.push(followUp.currentDate, followUp.kinesologistName, patientId, "PACE", fmt(followUp.evaluationType));
    
    // Santé et programme
    newRow.push(
        followUp.selfHealthRating, 
        levelLabel(followUp.programDifficultyLevel), 
        fmt(followUp.averagePrescribedExerciseDone),
        fmt(followUp.exercisePrescriptionPracticeWay),
        fmt(followUp.prescripedExerciseOpinion)
    );

    // Difficulté par exercice
    newRow.push(
        fmt(followUp.exercise1Difficulty),
        fmt(followUp.exercise2Difficulty),
        fmt(followUp.exercise3Difficulty),
        fmt(followUp.exercise4Difficulty)
    );

    // Satisfaction et douleur
    const modifications = normalizeSelectionList(followUp.modificationToAddress);
    newRow.push(
        fmt(followUp.apSatisfactionLevel),
        fmt(followUp.programPainLevel),
        fmt(followUp.frequencyOfPain),
        fmt(followUp.originOfPain),
        modifications.includes("none") ? "1" : "0",
        modifications.includes("perform-easy-only") ? "1" : "0",
        modifications.includes("decrease-repetitions") ? "1" : "0",
        modifications.includes("increase-rest") ? "1" : "0",
        modifications.includes("decrease-sets") ? "1" : "0",
        modifications.includes("remove-one-exercise") ? "1" : "0",
        modifications.includes("remove-two-exercises") ? "1" : "0"
    );

    // Securite
    newRow.push(
        fmt(followUp.feelingOfSafety),
        !followUp.feelingOfSafety && followUp.safetyFeelWhy ? followUp.safetyFeelWhy : "",
        !followUp.feelingOfSafety && followUp.safetyFeelCorrection ? followUp.safetyFeelCorrection : ""
    );

    // Marche
    newRow.push(
        fmt(followUp.hasWalkedPastWeeks),
        followUp.hasWalkedPastWeeks && followUp.hasWalkedFrequency ? fmt(followUp.hasWalkedFrequency) : "",
        followUp.hasWalkedPastWeeks && followUp.hasWalkedAverage ? `${followUp.hasWalkedAverage} min.` : "",
        followUp.hasWalkedPastWeeks && followUp.walkingPrescriptionPracticeWay ? fmt(followUp.walkingPrescriptionPracticeWay) : ""
    );

    // Chutes
    newRow.push(
        fmt(followUp.hasFallenPastWeeks),
        followUp.hasFallenPastWeeks && followUp.timesFallenCount ? followUp.timesFallenCount : "",
        followUp.hasFallenPastWeeks && followUp.fallCircumstances ? followUp.fallCircumstances : ""
    );

    // Motivation
    newRow.push(
        fmt(followUp.prescripedApMotivation),
        !followUp.prescripedApMotivation && followUp.notMotivatedReason ? followUp.notMotivatedReason : ""
    );
    // Autre activité physique

    newRow.push(fmt(followUp.otherActivityIntegration));
    if (followUp.otherActivityIntegration) {
        newRow.push(
            followUp.additionalActivity1Name ? followUp.additionalActivity1Name : "",
            followUp.additionalActivity1Frequency ? fmt(followUp.additionalActivity1Frequency) : "",
            followUp.additionalActivity1Length ? followUp.additionalActivity1Length : "",
            followUp.additionalActivity1Intensity ? fmt(followUp.additionalActivity1Intensity) : "",
            fmt(followUp.anotherActivityIntegration)
        );
    } else {
        newRow.push("", "", "", "", "");
    }

    if (followUp.otherActivityIntegration && followUp.anotherActivityIntegration) {
       newRow.push(
            followUp.additionalActivity2Name ? followUp.additionalActivity2Name : "",
            followUp.additionalActivity2Frequency ? fmt(followUp.additionalActivity2Frequency) : "",
            followUp.additionalActivity2Length ? followUp.additionalActivity2Length : "",
            followUp.additionalActivity2Intensity ? fmt(followUp.additionalActivity2Intensity) : "",
            fmt(followUp.yetAnotherActivityIntegration)
       );
    } else {
        newRow.push("", "", "", "", "");
    }

    if (followUp.otherActivityIntegration && followUp.anotherActivityIntegration && followUp.yetAnotherActivityIntegration) {
        newRow.push(
            followUp.additionalActivity3Name ? followUp.additionalActivity3Name : "",
            followUp.additionalActivity3Frequency ? fmt(followUp.additionalActivity3Frequency) : "",
            followUp.additionalActivity3Length ? followUp.additionalActivity3Length : "",
            followUp.additionalActivity3Intensity ? fmt(followUp.additionalActivity3Intensity) : "",
       );
    } else {
        newRow.push("", "", "", "");
    }

    // Consultation
    newRow.push(
        fmt(followUp.hasSeenDoctor),
        followUp.hasSeenDoctor && followUp.timesVisitedDoctorCount ? followUp.timesVisitedDoctorCount : "",
        followUp.hasSeenDoctor && followUp.doctorVisitReasons ? followUp.doctorVisitReasons : "",
        fmt(followUp.hasBeenToHospital),
        followUp.hasBeenToHospital && followUp.timesVisitedHospitalCount ? followUp.timesVisitedHospitalCount : "",
        followUp.hasBeenToHospital && followUp.hospitalVisitReasons ? followUp.hospitalVisitReasons : "",
        fmt(followUp.hasSeenOtherProfessional),
        followUp.hasSeenOtherProfessional && followUp.timesVisitedSpecialistCount ? followUp.timesVisitedSpecialistCount : "",
        followUp.hasSeenOtherProfessional && followUp.specialistVisitReasons ? followUp.specialistVisitReasons : ""
    );
    return newRow;
}

export const exportFollowUpPaceCsv = async (followUp, patientId) => {
    if (!followUp || !patientId) {
        return false;
    }

    let newCSV = new FollowUpCsvBuilder(CSV_DELIMITER);
    let row = makeFollowUpPaceRow(followUp, patientId);
    
    newCSV.addRow(row);
    return newCSV.saveToFile(patientId, followUp.currentDate, followUp.evaluationType);
}

export const exportAllFollowUpsPaceCsv = async (followUps, patientId) => {
    if (!Array.isArray(followUps) || followUps.length === 0 || !patientId) {
        return false;
    }

    let newCSV = new FollowUpCsvBuilder(CSV_DELIMITER);
    for (let i = 0; i < followUps.length; i++) {
        let row = makeFollowUpPaceRow(followUps[i], patientId);
        newCSV.addRow(row);
    }
    return newCSV.saveToFile(patientId, "", "all");
}
